<template>
  <div
    v-if="!!currentOffer && isActiveByStock"
    class="shopoffer-widget widget-danger"
  >
    <div class="inner">
      <div
        v-if="durationInDays > 1"
        class="offer-head"
      >
        <div>{{ $translate("Ecomsilio::Template.liveShoppingOfferName") }}</div>
        <span>{{ $translate("Ecomsilio::Template.liveShoppingUntil", {"days": durationInDays}) }}</span>
      </div>
      <div
        v-else
        class="offer-head"
      >
        <div>{{ $translate("Ecomsilio::Template.liveShoppingOfferName") }}</div>
        <span>{{ $translate("Ecomsilio::Template.liveShoppingUntilToday") }}</span>
      </div>
      <div class="offer-body">
        <a
          class="img-link"
          :href="item.texts.urlPath+'_'+item.item.id"
        >
          <div
            v-if="!isNaN(itemPriceRebatePercentage) && itemPriceRebatePercentage > 0"
            class="prices-rebate"
          >-{{ itemPriceRebatePercentage }}%</div>
          <lazy-img
            picture-class="img-fluid d-block"
            :image-url="item.images.all[0].urlMiddle"
            :alt="item.texts.name1"
            :title="item.texts.name1"
          />
        </a>
        <div class="shopoffer-details">
          <a
            class="thumb-title"
            :href="item.texts.urlPath+'_'+item.item.id"
          >{{ item | itemName }}</a>
          <div
            v-if="item.texts.shortDescription != ''"
            class="offer-description"
          >
            {{ item.texts.shortDescription }}
          </div>
          <div class="prices-container">
            <div class="live-shopping-price">
              <template v-if="!!item.item && item.item.salableVariationCount > 1">
                <span v-html="$translate('Ceres::Template.itemFromPrice', {'price': prices.price.unitPrice.formatted})" /><sup>*</sup>
              </template>
              <template v-else>
                {{ prices.price.unitPrice.formatted }}<sup>*</sup>
              </template>
            </div>
            <template v-if="prices.rrp && prices.rrp.unitPrice.value > 0">
              <span
                v-if="prices.isRrpDefaultPrice"
                class="shopoffer-old-price"
                v-html="oldPriceBefore"
              />
              <span
                v-else
                class="shopoffer-old-price"
                v-html="oldPriceRrp"
              />
            </template>
          </div>
          <div class="live-shopping-prices-additional-info">
            <div
              v-if="!(item.unit.unitOfMeasurement === 'C62' && item.unit.content === 1)"
              class="live-shopping-unit-price"
            >
              <span>{{ item.unit.content }}</span>
              <span>{{ item.unit.names.name }}</span>
              <span v-if="item.variation.mayShowUnitPrice">| {{ prices.price.basePrice }}</span>
            </div>
          </div>
          <div class="offer-cta">
            <div class="offer-countdown">
              <hr class="live-shopping-countdown-separator">
              <div
                v-if="!!duration"
                class="live-shopping-countdown-heading"
              >
                {{ $translate("Ceres::Template.liveShoppingOfferEndsIn") }}
              </div>
              <div
                v-if="!!duration"
                class="live-shopping-countdown-thread-container"
              >
                <div class="live-shopping-countdown-thread">
                  <div class="live-shopping-countdown-thread-number offer-hours">
                    {{ duration.hours }}
                  </div>
                  <div class="small">
                    {{ $translate("Ceres::Template.liveShoppingHours") }}
                  </div>
                </div>
                <div class="live-shopping-countdown-thread">
                  <div class="live-shopping-countdown-thread-number offer-minutes">
                    {{ duration.minutes }}
                  </div>
                  <div class="small">
                    {{ $translate("Ceres::Template.liveShoppingMinutes") }}
                  </div>
                </div>
                <div class="live-shopping-countdown-thread">
                  <div class="live-shopping-countdown-thread-number offer-seconds">
                    {{ duration.seconds }}
                  </div>
                  <div class="small">
                    {{ $translate("Ceres::Template.liveShoppingSeconds") }}
                  </div>
                </div>
              </div>
            </div>
            <a
              class="offer-button btn btn-primary btn-appearance"
              :href="item.texts.urlPath+'_'+item.item.id"
            >{{ $translate("Ecomsilio::Template.liveShoppingButtonText") }} <i
              aria-hidden="true"
              class="fa fa-arrow-right"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<script>
export default {
    name: "ShopOffer",
    props: {
        sorting: { type: String, default: "sorting.price.avg_asc" },
        liveShoppingId: {
            type: Number,
            default: 1,
            validator: value =>
            {
                return value % 1 === 0 && value >= 1 && value <= 10
            }
        }
    },
    data ()
    {
        return { currentInterval: null, duration: null }
    },
    computed: {
        currentOffer ()
        {
            return this.$store.state.liveShopping.liveShoppingOffers[this._uid]
        },
        item ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                return this.currentOffer.item
            }
            return null
        },
        currentLiveshopping ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                return this.currentOffer.liveShopping
            }
            return null
        },
        isActiveByStock ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                if (!(this.currentLiveshopping.quantitySold < this.currentLiveshopping.quantityMax))
                {
                    return this.currentOffer.item.item.salableVariationCount > 0
                }
                else
                {
                    return true
                }
            }
            return false
        },
        prices ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                const itemPrices = this.currentOffer.item.prices
                const prices = {
                    price: itemPrices.default,
                    rrp: itemPrices.rrp,
                    isRrpDefaultPrice: false
                }

                if (!(itemPrices.specialOffer === null || typeof itemPrices.specialOffer === typeof void 0))
                {
                    prices.price = itemPrices.specialOffer
                    prices.rrp = itemPrices.default || itemPrices.rrp
                    prices.isRrpDefaultPrice = !!itemPrices.default
                }
                return prices
            }
            return false
        },
        oldPriceBefore ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                return this.$translate("Ceres::Template.liveShoppingBefore", { price: "<del>" + this.prices.rrp.unitPrice.formatted + "</del>" })
            }
            return null
        },
        oldPriceRrp ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                return this.$translate("Ceres::Template.liveShoppingRrp", { price: "<del>" + this.prices.rrp.unitPrice.formatted + "</del>" })
            }
            return null
        },
        itemPriceRebatePercentage ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                const specialOfferPrice = this.prices.price.price.value
                const defaultPrice = (this.prices.rrp && this.prices.rrp.price.value) || 0

                let percentage = 100 - specialOfferPrice / defaultPrice * 100

                percentage = percentage.toFixed(App.config.item.storeSpecial)
                percentage = percentage.replace(".", App.decimalSeparator)
                return percentage
            }
            return null
        },
        durationInDays ()
        {
            if (!(this.currentOffer === null || typeof this.currentOffer === typeof void 0))
            {
                return Math.ceil((this.currentLiveshopping.toTime - (new Date().getTime() / 1000)) / (60 * 60 * 24))
            }
            return null
        }
    },
    watch: {
        currentLiveshopping ()
        {
            this.initializeDataAndTimer()
        }
    },
    mounted ()
    {
        this.reloadOffer()
    },
    methods: {
        initializeDataAndTimer ()
        {
            clearInterval(this.currentInterval)
            this.calculations()
            this.currentInterval = setInterval(() =>
            {
                this.calculations()
            }, 1000)
        },
        calculations ()
        {
            let timeLeft = 0

            if (this.currentLiveshopping.toTime - (new Date().getTime() / 1000) <= 0)
            {
                clearInterval(this.currentInterval)
            }
            else
            {
                timeLeft = this.currentLiveshopping.toTime - (new Date().getTime() / 1000)
            }
            this.duration = this.getDuration(timeLeft)
        },
        getDuration (seconds)
        {
            let hours = Math.floor(seconds / (60 * 60))

            if (hours / 10 < 1)
            {
                hours = "0" + hours
            }
            seconds = seconds - (hours * 60 * 60)
            let minutes = Math.floor(seconds / 60)

            if (minutes / 10 < 1)
            {
                minutes = "0" + minutes
            }
            seconds = Math.floor(seconds - (minutes * 60))
            if (seconds / 10 < 1)
            {
                seconds = "0" + seconds
            }
            return { hours, minutes, seconds }
        },
        reloadOffer ()
        {
            this.$store.dispatch("retrieveLiveShoppingOffer", { liveShoppingId: this.liveShoppingId, sorting: this.sorting, uid: this._uid })
        }
    }
}
</script>
